import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { fetchExpensesMappedheadsFailure, fetchExpensesMappedheadsSuccess } from './actions';
import { post } from 'helpers/api_helper';

function* fetchHeadsSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_EXPENSES_FETCH_MASTER_HEADS, formData);
    yield put({ type: types.FETCH_EXPENSES_HEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EXPENSES_HEADS_FAILURE, payload: error.message });
  }
}

function* saveHeadSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_SAVE_HEAD, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Expenses Head!');
    }

    yield put({ type: types.SAVE_EXPENSES_HEAD_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');

  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_EXPENSES_HEAD_FAILURE, payload: error });
  }
}

function* changeHeadStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_CHANGE_HEAD_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_EXPENSES_HEAD_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_EXPENSES_HEAD_STATUS_FAILURE, payload: error });
  }
}


// 1. Fetch Subheads
function* fetchSubheadsSaga(action) {
  const { unit_id, head_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_EXPENSES_FETCH_MASTER_SUB_HEADS, formData);
    yield put({ type: types.FETCH_EXPENSES_SUBHEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EXPENSES_SUBHEADS_FAILURE, payload: error.message });
  }
}

// 2. Save Subhead
function* saveSubheadSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_SAVE_SUB_HEAD, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Subhead!');
    }

    yield put({ type: types.SAVE_EXPENSES_SUBHEAD_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_EXPENSES_SUBHEAD_FAILURE, payload: error });
  }
}

// 3. Change Subhead Status
function* changeSubheadStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_CHANGE_SUB_HEAD_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update subhead status!');
    }

    yield put({ type: types.CHANGE_EXPENSES_SUBHEAD_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message || 'Status updated successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_EXPENSES_SUBHEAD_STATUS_FAILURE, payload: error });
  }
}

function* fetchExpensesMappedheadsSaga(action) {
  try {
    const { unit_id, head_id } = action.payload;
    const formData = new FormData();
    formData.append('head_id', head_id);
    formData.append('unit_id', unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_MASTER_MAPPED_HEADS, formData);
    yield put(fetchExpensesMappedheadsSuccess(response.data));
  } catch (error) {
    yield put(fetchExpensesMappedheadsFailure(error.message || 'Something went wrong'));
  }
}

function* fetchMappedHeadsSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_MAPPED_HEADS_LIST, formData);
    yield put({ type: types.FETCH_MAPPED_HEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_MAPPED_HEADS_FAILURE, payload: error.message });
  }
}

function* saveMappedHeadSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MAPPED_HEADS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Mapped Head!');
    }

    yield put({ type: types.SAVE_MAPPED_HEAD_SUCCESS, payload: response.data });

    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_MAPPED_HEAD_FAILURE, payload: error.message });
  }
}

function* changeMappedHeadStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_MAPPED_HEADS_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.CHANGE_MAPPED_HEAD_STATUS_SUCCESS, response });

    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing the status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_MAPPED_HEAD_STATUS_FAILURE, payload: error.message });
  }
}

// GET EXPENSES
function* fetchExpenseEntrySaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_EXPENSES_GET_ENTRY, formData);

    yield put({ type: types.FETCH_EXPENSE_ENTRY_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EXPENSE_ENTRY_FAILURE, payload: error.message });
  }
}

// SAVE EXPENSE
function* saveExpenseEntrySaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_SAVE_ENTRY, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Expense Entry!');
    }

    yield put({ type: types.SAVE_EXPENSE_ENTRY_SUCCESS, payload: response.data });

    Swal.fire('Success', response.message || 'Expense saved successfully!', 'success');
  } catch (error) {
    yield put({ type: types.SAVE_EXPENSE_ENTRY_FAILURE, payload: error.message });

    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving the expense!',
      icon: 'error',
      confirmButtonText: 'OK',
    });
  }
}

function* fetchExpensesEntryMappedHeadsSaga(action) {
  const { unit_id, head_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('head_id', head_id);
    formData.append('unit_id', unit_id); head_id

    const response = yield call(post, process.env.REACT_APP_EXPENSES_ENTRY_MAPPED_HEADS, formData);

    yield put({
      type: 'FETCH_EXPENSES_ENTRY_MAPPED_HEADS_SUCCESS',
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: 'FETCH_EXPENSES_ENTRY_MAPPED_HEADS_FAILURE',
      payload: error.message,
    });
  }
}

function* changeExpensesEntryStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_ENTRY_CHANGE_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change expense entry status!');
    }

    yield put({
      type: 'CHANGE_EXPENSES_ENTRY_STATUS_SUCCESS',
      payload: response,
    });

    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing expense entry status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({
      type: 'CHANGE_EXPENSES_ENTRY_STATUS_FAILURE',
      payload: error.message,
    });
  }
}

function* fetchExpenseEntryReportSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_ENTRY_REPORTS, action.payload);
    yield put({ type: types.FETCH_EXPENSE_ENTRY_REPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EXPENSE_ENTRY_REPORT_FAILURE, payload: error.message });
  }
}

// function* fetchExpensesApprovalListsSaga(action) {
//   try {
//     const response = yield call(post, process.env.REACT_APP_EXPENSES_GET_APPROVALLISTS, action.payload);
//     yield put({ type: types.FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS, payload: response.data });
//   } catch (error) {
//     yield put({ type: types.FETCH_EXPENSES_APPROVAL_LISTS_FAILURE, payload: error.message });
//   }
// }

function* fetchExpensesApprovalListsSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_EXPENSES_GET_APPROVALLISTS, formData);
    yield put({ type: types.FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EXPENSES_APPROVAL_LISTS_FAILURE, payload: error.message });
  }
}

function* saveExpensesApprovalListsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EXPENSES_SAVE_APPROVALLISTS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save expense approval!');
    }

    yield put({ type: types.SAVE_EXPENSES_APPROVAL_LISTS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message || 'Expense approval saved successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving expense approval!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_EXPENSES_APPROVAL_LISTS_FAILURE, payload: error.message });
  }
}

function* fetchExpensesMappedGridheadsSaga(action) {
  const { unit_id, head_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_EXPENSES_FETCH_GRID_MASTER_HEADS, formData);
    yield put({ type: types.FETCH_EXPENSES_HEADS_GRID_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_EXPENSES_HEADS_GRID_FAILURE, payload: error.message });
  }
}

export default function* expensesMasterSaga() {
  yield takeLatest(types.FETCH_EXPENSES_HEADS_REQUEST, fetchHeadsSaga);
  yield takeLatest(types.SAVE_EXPENSES_HEAD_REQUEST, saveHeadSaga);
  yield takeLatest(types.CHANGE_EXPENSES_HEAD_STATUS_REQUEST, changeHeadStatusSaga);

  // Subhead Sagas
  yield takeLatest(types.FETCH_EXPENSES_SUBHEADS_REQUEST, fetchSubheadsSaga);
  yield takeLatest(types.SAVE_EXPENSES_SUBHEAD_REQUEST, saveSubheadSaga);
  yield takeLatest(types.CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST, changeSubheadStatusSaga);

  yield takeLatest(types.FETCH_EXPENSES_MAPPED_HEADS_REQUEST, fetchExpensesMappedheadsSaga);

  yield takeLatest(types.FETCH_MAPPED_HEADS_REQUEST, fetchMappedHeadsSaga);
  yield takeLatest(types.SAVE_MAPPED_HEAD_REQUEST, saveMappedHeadSaga);
  yield takeLatest(types.CHANGE_MAPPED_HEAD_STATUS_REQUEST, changeMappedHeadStatusSaga);

  yield takeLatest(types.FETCH_EXPENSE_ENTRY_REQUEST, fetchExpenseEntrySaga);
  yield takeLatest(types.SAVE_EXPENSE_ENTRY_REQUEST, saveExpenseEntrySaga);

  yield takeLatest(types.FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST, fetchExpensesEntryMappedHeadsSaga);
  yield takeLatest(types.CHANGE_EXPENSES_ENTRY_STATUS_REQUEST, changeExpensesEntryStatusSaga);
  yield takeLatest(types.FETCH_EXPENSE_ENTRY_REPORT_REQUEST, fetchExpenseEntryReportSaga);
  yield takeLatest(types.FETCH_EXPENSES_APPROVAL_LISTS_REQUEST, fetchExpensesApprovalListsSaga);
  yield takeLatest(types.SAVE_EXPENSES_APPROVAL_LISTS_REQUEST, saveExpensesApprovalListsSaga);

  yield takeLatest(types.FETCH_EXPENSES_HEADS_GRID_REQUEST, fetchExpensesMappedGridheadsSaga);
}